import {useGetLkNotificationListQuery} from "@/api/ReferenceBooks/Lists/LkNotification/List/LkNotificationListApiSlice";
import {usePermissions} from "@/hooks/usePermissions";

export function LkNotificationPrefetcher() {
    const {hasPermission, isLoading: isPermissionsLoading} = usePermissions();

    useGetLkNotificationListQuery({}, {
        skip: isPermissionsLoading || !hasPermission('error-types.show'),
    });

    return null;
}
